import { API_ROOT } from '../../config/config'
import { doDownload } from './utils'

// const API_ROOT = 'http://localhost:9012/api'

//download ไฟล์
export const downloadSubprojectFile = (pathFile) => {
  const url = `${API_ROOT}/subproject/file-download?path=${pathFile || ''}`
  return doDownload(url)
}
